var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationBlocExperience(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 260 185",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e7f3fe;opacity:0.38;}.cls-2,.cls-22,.cls-38{stroke-miterlimit:10;}.cls-2,.cls-38{stroke-width:0.82px;}.cls-2{fill:url(#D\xE9grad\xE9_sans_nom_33);stroke:url(#D\xE9grad\xE9_sans_nom_33-2);}.cls-3{fill:#303c60;}.cls-4{fill:url(#D\xE9grad\xE9_sans_nom_33-3);}.cls-5{fill:url(#D\xE9grad\xE9_sans_nom_33-4);}.cls-6{fill:url(#D\xE9grad\xE9_sans_nom_33-5);}.cls-7{fill:#f09959;}.cls-11,.cls-8{fill:#6791c9;}.cls-9{fill:url(#D\xE9grad\xE9_sans_nom_30);}.cls-10,.cls-11{opacity:0.46;}.cls-12{fill:url(#D\xE9grad\xE9_sans_nom_30-2);}.cls-13{fill:#e38540;}.cls-14{fill:#f5ce5c;}.cls-15{fill:url(#D\xE9grad\xE9_sans_nom_30-3);}.cls-16{fill:url(#D\xE9grad\xE9_sans_nom_30-4);}.cls-17{fill:#fff;}.cls-18{fill:url(#D\xE9grad\xE9_sans_nom_33-6);}.cls-19{fill:#dbe5eb;}.cls-20{fill:url(#D\xE9grad\xE9_sans_nom_33-7);}.cls-21{fill:url(#D\xE9grad\xE9_sans_nom_30-5);}.cls-22{stroke-width:0.92px;fill:url(#D\xE9grad\xE9_sans_nom_33-8);stroke:url(#D\xE9grad\xE9_sans_nom_33-9);}.cls-23{fill:url(#D\xE9grad\xE9_sans_nom_30-6);}.cls-24{fill:url(#D\xE9grad\xE9_sans_nom_30-7);}.cls-25{fill:url(#D\xE9grad\xE9_sans_nom_30-8);}.cls-26{fill:url(#D\xE9grad\xE9_sans_nom_30-9);}.cls-27{fill:url(#D\xE9grad\xE9_sans_nom_30-10);}.cls-28{fill:url(#D\xE9grad\xE9_sans_nom_30-11);}.cls-29{fill:url(#D\xE9grad\xE9_sans_nom_30-12);}.cls-30{fill:url(#D\xE9grad\xE9_sans_nom_30-13);}.cls-31{fill:url(#D\xE9grad\xE9_sans_nom_30-14);}.cls-32{fill:url(#D\xE9grad\xE9_sans_nom_30-15);}.cls-33{fill:url(#D\xE9grad\xE9_sans_nom_30-16);}.cls-34{fill:url(#D\xE9grad\xE9_sans_nom_30-17);}.cls-35{opacity:0.15;}.cls-36{fill:url(#D\xE9grad\xE9_sans_nom_33-10);}.cls-37{fill:url(#D\xE9grad\xE9_sans_nom_33-11);}.cls-38{fill:none;stroke:#ea4b4b;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33",
    x1: 52.68,
    y1: 78.22,
    x2: 109.51,
    y2: 78.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c2057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17243e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-2",
    x1: 52.15,
    y1: 78.24,
    x2: 109.92,
    y2: 78.24,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-3",
    x1: 17.26,
    y1: 106.69,
    x2: 78.36,
    y2: 106.69,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-4",
    x1: 15.76,
    y1: 95.24,
    x2: 64.54,
    y2: 95.24,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-5",
    x1: 16.25,
    y1: 88.32,
    x2: 65.8,
    y2: 88.32,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30",
    x1: 31.84,
    y1: 135.1,
    x2: 117.98,
    y2: 135.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#16f7b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21bbee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-2",
    x1: 38.47,
    y1: 142.58,
    x2: 113.18,
    y2: 142.58,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-3",
    x1: 117.64,
    y1: 97.99,
    x2: 141.9,
    y2: 97.99,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-4",
    x1: 119.32,
    y1: 97.99,
    x2: 143.58,
    y2: 97.99,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-6",
    x1: 74.09,
    y1: 57.65,
    x2: 102.87,
    y2: 57.65,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-7",
    x1: 83.09,
    y1: 173.9,
    x2: 99.83,
    y2: 173.9,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-5",
    x1: 152.66,
    y1: 177.48,
    x2: 214.13,
    y2: 177.48,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-8",
    x1: 164.73,
    y1: 167.9,
    x2: 211.02,
    y2: 167.9,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-9",
    x1: 164.27,
    y1: 167.9,
    x2: 211.48,
    y2: 167.9,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-6",
    x1: 155.51,
    y1: 124.24,
    x2: 207.04,
    y2: 124.24,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-7",
    x1: 164.68,
    y1: 139.88,
    x2: 173.2,
    y2: 139.88,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-8",
    x1: 175.18,
    y1: 119.47,
    x2: 200.15,
    y2: 119.47,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-9",
    x1: 174.09,
    y1: 122.48,
    x2: 199.06,
    y2: 122.48,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-10",
    x1: 172.85,
    y1: 125.88,
    x2: 197.83,
    y2: 125.88,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-11",
    x1: 164.09,
    y1: 122.61,
    x2: 172.36,
    y2: 122.61,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-12",
    x1: 124.19,
    y1: 49.9,
    x2: 175.72,
    y2: 49.9,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-13",
    x1: 126.52,
    y1: 65.53,
    x2: 135.37,
    y2: 65.53,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-14",
    x1: 134.75,
    y1: 46.3,
    x2: 155.98,
    y2: 46.3,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-15",
    x1: 133.66,
    y1: 49.31,
    x2: 154.89,
    y2: 49.31,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-16",
    x1: 132.43,
    y1: 52.71,
    x2: 153.66,
    y2: 52.71,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-17",
    x1: 157.38,
    y1: 49.31,
    x2: 167.37,
    y2: 49.31,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-10",
    x1: 92.21,
    y1: 71.64,
    x2: 94.38,
    y2: 71.64,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-11",
    x1: 99.8,
    y1: 72.73,
    x2: 101.97,
    y2: 72.73,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2-2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.51,184.25S-27.62,137.12,14.84,86.6,114.13-15.58,152.22,4.4s34.66,45.25,76.5,81.82,32.15,65.6,24.66,80.31S244.64,185,244.64,185Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.85,43.28C82.36,33,90.82,39.12,97.11,46c5,5.47,5.72,6.69,9.87,12.36a5,5,0,0,1,1.1,2.82c.12,6.27,3.31,32.78-.24,41.93-4.13,10.66-55.16,15.54-55.16,15.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.53,109.17a.53.53,0,0,1-.53-.5.54.54,0,0,1,.5-.56,4.87,4.87,0,0,0,3.77-2.09c5.72-7.44,2.5-32.31-.3-45.83a.53.53,0,0,1,1-.21,182.42,182.42,0,0,1,3.3,24.34c.65,11.22-.42,18.73-3.2,22.35a6,6,0,0,1-4.55,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M75.17,40.21C53,52.5,66.53,94.06,38.47,108.88c-7.77,4.11-31.65,24.94-16,52.41,10.23,18,40.83,14.1,50.9-1.81S75.17,40.21,75.17,40.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M16.29,134.71h-.07a.53.53,0,0,1-.45-.6,30.54,30.54,0,0,1,2.71-8.28,36.27,36.27,0,0,1,13.24-15c13-8.31,21.6-16.13,31.79-54.69a.52.52,0,1,1,1,.27c-4.92,18.63-9.8,31.23-15.36,39.64-5.16,7.82-10.47,11.57-16.88,15.67a34.74,34.74,0,0,0-15.47,22.51A.52.52,0,0,1,16.29,134.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M16.77,124a.6.6,0,0,1-.28-.08.54.54,0,0,1-.16-.73A40,40,0,0,1,28.48,110.7C46.71,98.85,49.73,92,64.78,53a.52.52,0,0,1,.68-.3.51.51,0,0,1,.3.68c-7.52,19.5-12,30.93-17,39-5.28,8.7-11.25,13.61-19.76,19.14A39.14,39.14,0,0,0,17.22,123.7.53.53,0,0,1,16.77,124Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M74.4,66.15A65.1,65.1,0,0,0,68,96.46s.88,5.6,4.39,6.78,8.5-2.36,8.21-7.07S81.73,80,83.48,75.86,74.4,66.15,74.4,66.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M34.16,176.59c.48,4.34-.6,4,3.23,4.7s10.68-1.93,10.68-1.93L40.39,165Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M68.88,87.93c-2.16,7-18.35,1.63-24,3.25s-10.53,25.48-11.34,46.9.27,38.49,2.43,41.2,37.77,3.79,41,2.71-27-14.64-27-14.64-1.89-24.94.54-37.68,24.28-29.54,24.28-29.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M76.43,90.1c5.67,8.67,20.5,7.59,25.63,14.64S118,150.55,118,150.55l11.33-39.31s9.19-1.55,6.2,4.88c-5.3,11.44-7.28,48.33-13,53.57-6.4,5.83-12.77,1.09-16.36-9.11-3.48-9.87-12.14-31.18-18.35-39.31s-13-21.14-13-21.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M51.88,91.18c11.33,13.28,33.45,12.74,38.31,11.12l4.86-1.63s3.77-1.36,7,2.44,11.06,27.65,12.41,33.07S118,150.55,118,150.55s-5.79,7-5.79,14,2.46,7.11,2.46,7.11-7.19-1.62-8.81-6-16.19-43.65-16.19-43.65l-40.2.82L50,167.35s-3.51-3.25-8.36,0S35.15,178.2,36,179.28s-1.62,1.08-1.62.27S29.76,159,33,126.42s9.45-36,12.95-36.32A11.4,11.4,0,0,1,51.88,91.18Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M113,171.12l.12,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M114.56,151.53c-2.34.73-6.3,9-6.3,9a163.23,163.23,0,0,1-11.69-47l-3.21,18.51c4.43,12,11.39,30.72,12.48,33.64,1.48,4,7.45,5.62,8.27,5.8-.23-.07-.72-.37-1.13-1.56-.24-.22-1.59-.86-1.84-1.09-2.16-2-1.26-6.68.18-11.93S116.9,150.81,114.56,151.53Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M51.39,122.86l-4.46-20.48c-4.86,6.86-5.4,30.36-3.42,46.44,1.62,13.19,4.05,16.62,5.72,18a4.85,4.85,0,0,1,.76.54l-.54-44.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M38.47,102.19c8.28,22.41,4.14,26.93,15,53.24,6.08,14.69,17.8,25.75,17.8,25.75a74.07,74.07,0,0,0,21.32,1.62c11.87-.81,20.56-1.63,20.56-1.63s-12.47-7.58-13-12.73-2.88-25.58.18-40c2.39-11.29-7.46-22.58-7.46-22.58L76.43,105Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M53,136.53c-1.44-5.24,6.12,1.63,18.53,2.89s26.26-.72,19.43,1.45-25.55-1.08-22.13,5.78c4,8.09,8.77,15.91,15.65,20.61,4.5,3.07,15.29,6,4.86,4.33s-21.59-13.91-26.44-21.86S53.36,137.7,53,136.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M80.53,94.11c.1-5.41,1.42-14.65,3-18.25,1.26-3-3.94-6.66-7-8.53l-2.58-.11c-.39.86-.76,1.72-1.11,2.57-2.72,18,5.44,25.43,9.33,26.92a11.64,11.64,0,0,0,5.18.57A31.15,31.15,0,0,1,80.53,94.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M75.58,102.11a12.51,12.51,0,0,1-2.87-.35c-2.25-.55-7.62-2.65-8.87-10.18a.29.29,0,0,1,.25-.34.29.29,0,0,1,.34.24c1.19,7.18,6.29,9.17,8.42,9.7,3.32.81,6.84.06,8.19-1.76,1.09-1.45.44-4.54.43-4.57a.31.31,0,0,1,.23-.36.3.3,0,0,1,.35.23c0,.14.72,3.39-.53,5.06C80.42,101.26,78.14,102.11,75.58,102.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M101,73.22c-1.83,9.71-6.06,17.54-13.21,16.06S73.09,77.55,75.07,67.87,84.45,51.54,91.6,53,103.41,60.28,101,73.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M126.43,121.17s-13.22,35.69-13.85,39.4.63,6.05,1,6.05,11.6-19.33,11.6-19.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M127,119.6c1.08-3.61-.6-8.19-.6-8.19l4.8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M132.24,113.44H118.86a1.22,1.22,0,0,1-1.17-1.57l8.45-28.46a1.21,1.21,0,0,1,1.16-.87h13.39a1.22,1.22,0,0,1,1.16,1.57l-8.45,28.46A1.21,1.21,0,0,1,132.24,113.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M133.92,113.44H120.53a1.22,1.22,0,0,1-1.16-1.57l8.45-28.46a1.21,1.21,0,0,1,1.16-.87h13.39a1.22,1.22,0,0,1,1.16,1.57l-8.45,28.46A1.21,1.21,0,0,1,133.92,113.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M124.23,92.81c-1.43,5.16-2.39,9.41-2.15,9.47s1.6-4.06,3-9.23,2.38-9.4,2.14-9.47S125.66,87.64,124.23,92.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M133.32,121.89c.4-4.69,4.45-9.09,6-10.49a2.25,2.25,0,0,0,.72-1.67c0-2.34-.12-7.86-.6-8.51-.62-.82-2.15-11.39-2.87-11s.21,9.65.21,9.65l-2.66-1.24c-.92-.41-4.7,3.8-4.7,3.8s-1.77,4.5,3.08,2.58c5.75-2.29,1.43,4.09-2.4,8.19-3.16,3.37-.47,4.12-.47,4.12l2.55-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M131.88,125.59a4.72,4.72,0,0,1-1.39-.22c-1.25-.39-3.42-1.65-4-5.69a.3.3,0,0,1,.26-.34.29.29,0,0,1,.33.25c.5,3.46,2.17,4.72,3.48,5.17a3.16,3.16,0,0,0,2.18.07.32.32,0,0,1,.19-.23.3.3,0,0,1,.39.16.42.42,0,0,1-.1.45A1.93,1.93,0,0,1,131.88,125.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M131.37,124.42a9.67,9.67,0,0,1-1.2-.08c-2.32-.34-3.87-1.52-4.26-3.24a.3.3,0,0,1,.59-.13,3.74,3.74,0,0,0,3,2.63,5.42,5.42,0,0,0,3.39,0,.28.28,0,0,1,.4-.11.29.29,0,0,1,.11.41C133.21,124.24,132.34,124.42,131.37,124.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M100.24,78.28H100c-1.49-.23-2.29-2.76-1.84-5.76s2-5.18,3.47-4.94c.76.11,1.37.82,1.7,2a9.4,9.4,0,0,1,.13,3.78C103.06,76.18,101.66,78.28,100.24,78.28Zm1.2-9.93c-.88,0-2.07,1.69-2.46,4.28s.29,4.71,1.17,4.85,2.15-1.59,2.56-4.28a8.4,8.4,0,0,0-.12-3.43c-.23-.83-.62-1.35-1-1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M102.87,58.28c-27.28,16.14-28.78,5.3-28.78,5.3l1.62-15.42,16.18.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M76.2,67.16c.63,2.73-.23,5.27-1.94,5.67s-3.6-1.49-4.23-4.22S70.26,63.35,72,63,75.56,64.43,76.2,67.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M74.33,70.75a1.08,1.08,0,1,1-1.07-1.08A1.08,1.08,0,0,1,74.33,70.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M76.58,180.58s-10.29.13-10.42,1,.39,1.31,4,2,44.66.92,45.05.65,12.38-3.14,12.38-3.14l-28.78-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M82.18,173.7s7.38-3.25,9.54-1.81,8.39,8.08,8.39,8.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M99.7,180.56c-.14.17-.35.25-.46.16L84.06,169.37c-.82-.61-1.21-1.55-.81-2s1.38-.32,2.16.35l14.35,12.38C99.87,180.16,99.84,180.38,99.7,180.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M59.88,172.32s12.23,4.88,13.67,4.88,9.47-5.43,12.17-4.7,15.89,7.41,15.53,7.95-4.14,1.81-15.29,1.44-29.32-2-29.32-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M154.6,171.51h54.67a4.86,4.86,0,0,1,4.86,4.86v2.22a4.86,4.86,0,0,1-4.86,4.86H154.6a1.94,1.94,0,0,1-1.94-1.94v-8.07a1.94,1.94,0,0,1,1.94-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M206,173.53H152.67a4.09,4.09,0,0,0-.6,2.13v3.65a4.06,4.06,0,0,0,.6,2.12H206a3.46,3.46,0,0,0,3.44-3.46v-1A3.46,3.46,0,0,0,206,173.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M165.9,164.29h42.18a2.94,2.94,0,0,1,2.94,2.94v1.34a2.94,2.94,0,0,1-2.94,2.94H165.9a1.17,1.17,0,0,1-1.17-1.17v-4.88A1.17,1.17,0,0,1,165.9,164.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M204.89,165.51H164.73a2.17,2.17,0,0,0-.45,1.29V169a2.14,2.14,0,0,0,.45,1.28h40.16a2.38,2.38,0,0,0,2.59-2.09v-.6A2.38,2.38,0,0,0,204.89,165.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M197.58,135H157.15a1.6,1.6,0,0,1-1.49-2.36l6.11-16.88a3.73,3.73,0,0,1,3.2-2.35H205.4a1.59,1.59,0,0,1,1.49,2.35l-6.11,16.88A3.72,3.72,0,0,1,197.58,135Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M196.21,133.27H159.8a1.38,1.38,0,0,1-1.29-2l5.06-14a3.23,3.23,0,0,1,2.77-2h36.41a1.38,1.38,0,0,1,1.29,2l-5.06,14A3.23,3.23,0,0,1,196.21,133.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M173.2,134.05c-3.36,8.9-8.52,11.65-8.52,11.65s3.67-5.1,3.14-7.59a5.44,5.44,0,0,0-2.5-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M199.14,120.19H175.67a.48.48,0,0,1-.45-.71v0a1.1,1.1,0,0,1,1-.7h23.47c.38,0,.58.31.44.7v0A1.11,1.11,0,0,1,199.14,120.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M198.05,123.2H174.58a.48.48,0,0,1-.45-.71v0a1.1,1.1,0,0,1,1-.7h23.47c.38,0,.58.31.44.7v0A1.11,1.11,0,0,1,198.05,123.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M196.81,126.6H173.34c-.38,0-.58-.32-.44-.71v0a1.1,1.1,0,0,1,1-.7h23.48c.38,0,.58.31.44.7v0A1.11,1.11,0,0,1,196.81,126.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M172,122.61c-.92,2.56-3.37,4.64-5.45,4.64s-3-2.08-2.1-4.64,3.38-4.65,5.46-4.65S172.93,120,172,122.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M183.92,78.53h-2a.52.52,0,0,1-.49-.77l.6-1.66a1.22,1.22,0,0,1,1.05-.77h2a.53.53,0,0,1,.49.77l-.6,1.66A1.24,1.24,0,0,1,183.92,78.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M190.35,78.53h-2a.52.52,0,0,1-.49-.77l.6-1.66a1.21,1.21,0,0,1,1-.77h2a.53.53,0,0,1,.49.77l-.6,1.66A1.24,1.24,0,0,1,190.35,78.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M196.78,78.53h-2a.52.52,0,0,1-.49-.77l.6-1.66a1.21,1.21,0,0,1,1-.77h2a.52.52,0,0,1,.48.77l-.6,1.66A1.21,1.21,0,0,1,196.78,78.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M166.26,60.69H125.83a1.59,1.59,0,0,1-1.49-2.35l6.11-16.88a3.72,3.72,0,0,1,3.2-2.36h40.43a1.6,1.6,0,0,1,1.49,2.36l-6.11,16.88A3.73,3.73,0,0,1,166.26,60.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M164.89,58.92H128.48a1.38,1.38,0,0,1-1.29-2l5.06-14a3.22,3.22,0,0,1,2.77-2h36.41a1.38,1.38,0,0,1,1.29,2l-5.06,14A3.22,3.22,0,0,1,164.89,58.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M127.87,59.71c-3.09,8.9.08,11.64.08,11.64s0-5.1,2.36-7.58a15.26,15.26,0,0,1,5.06-3.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M155,47H135.2a.44.44,0,0,1-.41-.65l.05-.14a1,1,0,0,1,.88-.65h19.81a.44.44,0,0,1,.41.65l-.06.14A1,1,0,0,1,155,47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M153.92,50H134.11a.44.44,0,0,1-.41-.65l.05-.14a1,1,0,0,1,.88-.65h19.81a.44.44,0,0,1,.41.65l-.06.14A1,1,0,0,1,153.92,50Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M152.68,53.43h-19.8c-.36,0-.54-.29-.41-.65l.05-.14a1,1,0,0,1,.88-.65h19.8c.36,0,.54.29.41.65l-.05.14A1,1,0,0,1,152.68,53.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M206.12,84.87h-39c-.7,0-1.06-.29-.81-.64l.1-.15a2.44,2.44,0,0,1,1.74-.64h39c.7,0,1.06.29.81.64l-.1.15A2.44,2.44,0,0,1,206.12,84.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M204,89.85H165c-.7,0-1.06-.29-.81-.65l.11-.14a2.36,2.36,0,0,1,1.73-.65h39c.7,0,1.07.29.81.65l-.1.14A2.4,2.4,0,0,1,204,89.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M161.89,54.61H159a1.6,1.6,0,0,1-1.49-2.36l2.13-5.89a3.73,3.73,0,0,1,3.2-2.35h2.87a1.6,1.6,0,0,1,1.49,2.35l-2.14,5.89A3.71,3.71,0,0,1,161.89,54.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M96.46,67.85s.11,9.62.86,11a3.13,3.13,0,0,1-3,1.94s2.47,1.3,4.41-1.73C97.32,75.85,97.32,73.58,96.46,67.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M92.76,78.27l-.44,0c-2.27-.35-3.64-3.3-3.12-6.7a8,8,0,0,1,1.76-4,3.57,3.57,0,0,1,3.21-1.41c2.27.35,3.64,3.29,3.12,6.69C96.81,76,94.87,78.27,92.76,78.27Zm1-11.16a2.75,2.75,0,0,0-2,1.09,6.93,6.93,0,0,0-1.51,3.5c-.42,2.73.61,5.24,2.24,5.49s3.36-1.84,3.78-4.57-.62-5.24-2.25-5.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M90.28,69.29l-.15,0L72.5,64.21a.53.53,0,0,1-.36-.65.52.52,0,0,1,.65-.37l17.63,5.06a.53.53,0,0,1,.36.66A.51.51,0,0,1,90.28,69.29Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-36",
    cx: 93.29,
    cy: 71.64,
    rx: 1.08,
    ry: 1.09
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-37",
    cx: 100.89,
    cy: 72.73,
    rx: 1.08,
    ry: 1.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M89,82.54c0,1.21,3.4,2.18,7.6,2.18"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationBlocExperience);
export default __webpack_public_path__ + "static/media/ILLUSTRATION-BLOC-experience.8b5ac63c1ac686ec1c3d38b52bf373f3.svg";
export { ForwardRef as ReactComponent };